export default "__VITE_ASSET__Ctquioif__"